import { useMemo } from "react";

import { useAuth } from "./state/useAuth";
import {
    hasAllPermissions,
    hasAnyPermission,
    hasPermission,
    normalizePermissionList,
    type PermissionCode,
} from "./permissions";

export const usePermissions = () => {
    const { user } = useAuth();

    const effectivePermissions = useMemo(
        () => normalizePermissionList(user?.effectivePermissions, user?.role),
        [user?.effectivePermissions, user?.role]
    );

    const explicitPermissions = useMemo(
        () => normalizePermissionList(user?.permissions, user?.role),
        [user?.permissions, user?.role]
    );

    return {
        permissions: explicitPermissions,
        effectivePermissions,
        hasPermission: (permission: PermissionCode) =>
            hasPermission(effectivePermissions, permission),
        hasAnyPermission: (permissions: readonly PermissionCode[]) =>
            hasAnyPermission(effectivePermissions, permissions),
        hasAllPermissions: (permissions: readonly PermissionCode[]) =>
            hasAllPermissions(effectivePermissions, permissions),
    };
};
